import * as React from 'react'
import { useHits } from 'react-instantsearch-hooks-web'
import { Hit, BaseHit } from 'instantsearch.js'

import styled from 'styled-components'
import { fbEnrichVideosFromIds } from '../../../data/FirebaseEnrich'
import { VideoData } from '../../../interfaces'
import VideoHitItem from './VideoHitItem'

const OuterDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`

const Title = styled.div`
  font-weight: 700;
  font-size: 24px;
  color: white;
  margin-bottom: 5px;
`

interface Props {
  setNoResults: (noResults: boolean) => void
  onClick: () => void
}

const VideoHits = ({ setNoResults, onClick }: Props): JSX.Element => {
  const { hits } = useHits()
  const [videos, setVideos] = React.useState<VideoData[]>([])

  const transform = async (items: Hit<BaseHit>[]): Promise<void> => {
    const videoIds: string[] = items.map((item) => item.objectID).filter(Boolean) as string[]
    const videos = await fbEnrichVideosFromIds(videoIds)
    setVideos(videos)
  }

  React.useEffect(() => {
    if (hits.length === 0) {
      setNoResults(true)
    } else {
      setNoResults(false)
    }
    transform(hits)
  }, [hits])

  if (videos.length === 0 || hits.length === 0) {
    return <></>
  }

  return (
    <OuterDiv>
      <Title>VIDEOS</Title>
      {videos.map((video, i) => {
        return <VideoHitItem key={`video-hit-item-${i}`} video={video} onClick={onClick} />
      })}
    </OuterDiv>
  )
}

export default VideoHits
